<template>
	<div v-if="isload" class="createorder_returnexchange">
		<el-row>
			<el-col :span="24">
				<maininfo :ref="'maininfo_'+l_id" l_mode="主信息-退换货"></maininfo>
			</el-col>
		</el-row>
		<el-row>
			<!-- <el-col :span="12"><senderaddr :ref="'senderaddr_'+l_id" title="寄件信息" l_mode="寄件人信息-退换货"></senderaddr></el-col> -->
			<el-col :span="12"><receiveraddr :ref="'receiveraddr_'+l_id" title="收件信息" l_mode="收件人信息-退换货"></receiveraddr></el-col>
			<el-col :span="24">
				<gridlist :ref="'returnexchange_cargolist_'+l_id" :item="item" 
				:title="returnexchange_lang.cargolisttitle"></gridlist>
			</el-col>
		</el-row>
		<el-row v-if="!btnhidden" class="footerhandler">
			<el-col :span="4" class="submitBtn"><div @click="saveorder">{{$lang.label.public.savebtn}}</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import maininfo from '@/components/tools/maininfo.vue';
import senderaddr from '@/components/address/senderaddr_ssq.vue';
import receiveraddr from '@/components/address/receiveraddr_ssq.vue';
import gridlist from '@/components/tools/gridlist.vue'

export default {
	components: {
		senderaddr,
		receiveraddr,
		maininfo,
		gridlist
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			btnhidden:false,
			returnexchange:{},
			l_id:'',
			t_id:'',
			type:'',
			isload:false,
			curpkval:'',
			orderinfo:'',
			divclass:'createorder_returnexchange'
		}
	},
	created() {
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	methods: {
		init(param) {
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode(this.type,this).then(res=>{
				//debugger
				if(res.state=='1')
					that.returnexchange=that.$lang.label[that.type];
				if(this.curpkval!='')//加载单据信息
					this.GetOrderInfo();
				else
					this.GetPageLayout();
			});
		},
		GetOrderInfo(){
			var that=this;
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			var paraminfo={
				pkval:this.curpkval,
				l_id:this.l_id
			}
			this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
				debugger
				this.$tool.loadingclose();
				if (res != '') {
					that.orderinfo = res;
					that.GetPageLayout();
				} else
					this.$tool.message(that.$lang.label.public.getinfofailed, "0");
			});
		},
		GetPageLayout(){
			var that = this;
			//this.truncatepage();
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.GetTransFormat({
				p_mode: this.type
			}).then(res => {
				this.$tool.loadingclose();
				var t_id="",pagetranscol="",syscol="";
				if (res.state == '1') {
					if (res.set != undefined) {
						if(res.set.t_id!=undefined)
						{
							t_id = res.set.t_id;
							pagetranscol=res.set.pagetranscol;
							syscol= res.set.t_syscol
						}
					}
					var list=[];
					if(t_id==''&&res.list!=undefined){
						list = res.list.filter(function(re) {
							return re.t_type == that.type;
						});
						if(list.length>0){
							t_id = list[0].t_id;
							pagetranscol=list[0].pagetranscol;
							syscol= list[0].t_syscol;
						}
					}
					if(t_id!=''){
						that.t_id=t_id;
						that.isload=true;
						that.pagetranscol=pagetranscol;
						if(that.orderinfo!='')
							that.orderinfo = that.$tool.TransOrderInfo(pagetranscol, that);
						
						that.$nextTick(function(){
							that.$refs['maininfo_'+that.l_id].init({
								pkval:that.curpkval,
								iscopy:that.iscopy,
								type:that.type,
								orderinfo:that.orderinfo,
								syscol:syscol,
								t_id: t_id,
								isdetail:true,
							});
							//that.$refs['senderaddr_'+that.l_id].init({ syscol: syscol, orderinfo: that.orderinfo,isdetail:true});
							
							that.$refs['receiveraddr_'+that.l_id].init({ syscol: syscol, orderinfo: that.orderinfo,isdetail:true });
							that.$refs['returnexchange_cargolist_'+that.l_id].init(
							{
							 pkval:that.curpkval,
							 iscopy:that.iscopy,
							 type:that.type,
							 orderinfo:that.orderinfo,
							 syscol:syscol,
							 t_id: t_id
							});
						});
					}
				}
			});
					
		},
		saveorder(){
			
		},
		cancel() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
	}
 }
</script>

<style>
</style>